import React, { FC } from 'react';
import { Button as MaterialButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export interface ButtonProps {
    // Optional:
    disabled?: boolean;
    onClick?: () => void;
}

const useStyles = makeStyles(theme => ({
    containedPrimary: {
        color: theme.palette.fixedPrimary.primary,
        fontWeight: 600,
        minWidth: 0,
        textTransform: 'none',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
        fontSize: 16,
        lineHeight: 1.5,
    },
}));

export const TextButton: FC<ButtonProps> = props => {
    const classes = useStyles();
    return <MaterialButton className={classes.containedPrimary} variant="text" disableElevation={true} {...props} />;
};
